import { useTranslation } from 'react-i18next'
import { appAboutOf } from '@/domain/app-catalog'

interface AppAboutRequest {
  // The app's name in REVER's catalog.
  appKey: string
  part: 'summary' | 'details'
  // The catalog's own description, for an app REVER has written none for.
  fallback?: string
}

export function useAppAbout() {
  const { t } = useTranslation()
  return ({ appKey, part, fallback = '' }: AppAboutRequest) => {
    const about = appAboutOf(appKey)
    return about
      ? t(`integrations_hub.app.about.${about}.${part}`, {
          // As the app's card shows it.
          name: appKey.replace(/_/g, ' '),
          // Plain text React escapes: i18next's own escaping would show "&amp;" in a name.
          interpolation: { escapeValue: false }
        })
      : fallback
  }
}
